/* eslint-disable */
<template>
  <div id="app">
    <div class="top_header clearfix">
      <div class="header_box">
        <a :href="indexUrl">
        <div class="top_header_l">
          <img v-if="URL_MAQIN==2" src="./assets/kjclogo.png" alt />
          <img v-if="URL_MAQIN==1" src="./assets/logo.png" alt />
        </div>
        </a>
        <div class="top_header_r clearfix">

          <div class="nav_list" @click="Jump_click">
            首页
            <span :class="URL_MAQIN==2? 'lv' :''"  v-if="indexClassList.indexOf($route.name)>-1"></span>
          </div>
          <!-- v2配置导航 -->
          <div class="nav_list" v-for="item in topNavList"><a :href="item.url">{{item.name}}</a></div>

          <div v-if="URL_MAQIN==1" class="nav_list" @click="ask_click">问答</div>

          <div class="nav_list" @click="home_click">
            学堂
            <span :class="URL_MAQIN==2? 'lv' :''"  v-if="indexClassList.indexOf($route.name)==-1"></span>
          </div>

          <div class="nav_list appHover" @click="AppDownLoad" v-if="URL_MAQIN==1">
            APP下载
            <div class="AppQrCode">
              <img src="./assets/img/appDownload.png" alt="">
              <p>扫码下载蜜蜂岛APP</p>
            </div>
          </div>

          <div class="nav_list1">
            <div class="phonto">
              <img :src="infor.avatar" alt />
            </div>
            <div class="name" @click="me_center">{{infor.nickname}}</div>
            <div class="tag">
              <img src="./assets/img/me_down.png" alt />
            </div>
            <div class="downBox">
              <div class="alt" @click="goShopUrl('/ucenter/order')">我的订单</div>
              <div class="alt" @click="goShopUrl('/ucenter/collage_list')">我的拼团</div>
              <div class="alt" @click="goShopUrl('/ask/userCenter')" v-if="URL_MAQIN==1">我的提问</div>
              <div class="alt" @click="off_login">退出登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
import appConfig from "@/api/appConfig";
import { Userinfo,categoryListTop } from "@/api/index.js";
export default {
  data() {
    return {
      infor: {},
      URL_MAQIN: this.GLOBAL.PLATFORM,
      indexUrl:appConfig.ShoppUrl,
      indexClassList:['question_bank_center'],//首页归类路由名列表
      topNavList:''
    };
  },
  created(){
    this.getNavConfig()
  },
  mounted() {
    this.userinfo();
  },
  // updated(){
  //   console.log(this.indexClassList.indexOf(this.$route.name))
  // },
  methods: {
    Jump_click() {
      let url = appConfig.ShoppUrl;
      window.location.href = url;
    },
    AppDownLoad(){
      let url = appConfig.ShoppUrl + "/site/downLink";
      window.location.href = url;
    },
    // 获取配置导航栏
    getNavConfig(){
      categoryListTop().then(res=>{
        this.topNavList = res
      })
    },
    userinfo() {
      Userinfo().then(res => {
        console.log(res);
        this.infor = res;
      });
    },
    me_center() {
      let url = appConfig.ShoppUrl + "/ucenter/index";
      window.location.href = url;
    },
    off_login() {
      let url =
        appConfig.passportUrl +
        "/logout?redirect=" +
        encodeURIComponent(window.location.href);
      window.location.href = url;
    },
    goShopUrl(str){
      let url = appConfig.ShoppUrl + str
      window.open(url);
    },
    home_click() {
      this.$router.push({
        path: "/"
      });
    },
    ask_click(){
      let url = appConfig.ShoppUrl +"/ask"
      window.location.href = url;
    }
  }
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
.top_header {
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.07);
  margin-bottom: 36px;
  .header_box {
    width: 1368px;
    margin: auto;
    .top_header_l {
      float: left;
      img {
        margin-top: 7px;
        width: 115px;
        height: 47px;
      }
    }
    .top_header_r {
      float: right;
      .appHover:hover .AppQrCode{
        display: block;
      }
      .nav_list {
        cursor: pointer;
        position: relative;
        float: left;
        line-height: 60px;
        margin-left: 44px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        span {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translate(-50%, 0%);
          display: block;
          width: 40px;
          height: 6px;
          background: rgba(240, 209, 10, 1);
          border-radius: 5px;
        }
        .lv {
          background: #0cd56d;
        }
        >img {
          width: 32px;
          height: 32px;
          float: left;
          border-radius: 50%;
          margin: 15px 20px 0 0;
        }
        .name {
          float: left;
        }
        .AppQrCode{
          width:180px;
          height:180px;
          background:white;
          box-shadow:0px 4px 10px 0px rgba(0,0,0,0.05);
          border:1px solid rgba(238,238,238,1);    
          position: absolute;
          text-align: center;
          bottom: -180px;
          left: -58px;
          z-index: 999;
          font-size: 0;
          line-height: normal;
          display: none;
          img{
            width: 120px;
            height: 120px;
            margin-top: 19px;
            line-height: normal;
          }
          p{
            margin-top: 10px;
            font-size:16px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(51,51,51,1);  
            line-height: normal; 
          }
        }
      }
      .nav_list1 {
        cursor: pointer;
        position: relative;
        float: left;
        line-height: 60px;
        margin-left: 44px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        &:hover .downBox {
          display: block;
        }
        span {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translate(-50%, 0%);
          display: block;
          width: 40px;
          height: 6px;
          background: rgba(240, 209, 10, 1);
          border-radius: 5px;
        }
        .phonto {
          float: left;
          img {
            width: 32px;
            height: 32px;
            float: left;
            border-radius: 50%;
            margin: 15px 20px 0 0;
          }
        }
        .tag{
          float: left;
          margin-left: 10px;
          img{

          }
        }
        .name {
          float: left;
        }
        .downBox{
          display: none;
          position: absolute;
          left: 0;
          z-index: 999;
          // bottom: -60px;
          top: 60px;
          width: 175px;
          text-align: center;
          background: rgba(255, 255, 255, 1);
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(238, 238, 238, 1);
          .alt {
            
          }
        }
      }
    }
  }
}
</style>
